module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-main-container"
  }, [_c('router-view', {
    key: _vm.key,
    staticClass: "app-main-height"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5297806"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/components/VabAppMain/index.vue
// module id = 1116
// module chunks = 1